export type AdventureMembershipStatus = 'interested' | 'joined' | 'waitlist';

export type AdventureMembershipCounts = {
  interested: number;
  going: number;
  waitlist: number;
};

type AdventureMemberLike = {
  status?: string | null;
};

export const EMPTY_ADVENTURE_MEMBERSHIP_COUNTS: AdventureMembershipCounts = {
  interested: 0,
  going: 0,
  waitlist: 0,
};

export function buildAdventureMembershipCounts(
  members: AdventureMemberLike[] | null | undefined,
): AdventureMembershipCounts {
  const counts: AdventureMembershipCounts = { ...EMPTY_ADVENTURE_MEMBERSHIP_COUNTS };

  for (const member of members ?? []) {
    if (member.status === 'interested') {
      counts.interested += 1;
    }

    if (member.status === 'joined') {
      counts.going += 1;
    }

    if (member.status === 'waitlist') {
      counts.waitlist += 1;
    }
  }

  return counts;
}

export function isAdventureFull(maxGroupSize: number | null | undefined, counts: AdventureMembershipCounts): boolean {
  if (!maxGroupSize || maxGroupSize <= 0) {
    return false;
  }

  return counts.going >= maxGroupSize;
}

export function getAdventureStatusConfirmation(status: AdventureMembershipStatus): string {
  if (status === 'joined') {
    return "You're in! 🎉";
  }

  if (status === 'waitlist') {
    return "You're on the waitlist";
  }

  return 'Marked as interested';
}
